import Vue from 'vue'
import Router from 'vue-router'
import Tips from '@/components/Tips'
import Question from '@/components/Question'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Tips',
    component: Tips,
    meta: {
      title: 'Recharge'
    }
  },
  {
    path: '/question',
    name: 'question',
    component: Question,
    meta: {
      title: 'الأسئلة الشائعة'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js